import React from 'react';
import {setModalAdditional} from '../../../../redux/actions/app/appActions';
import {useDispatch} from 'react-redux';
import {ReactComponent as AvatarIcon} from '../../../../assets/icons/avatarIcon.svg';
import {useTranslation} from 'react-i18next';

const AvatarField = ({acceptedFiles, avatar, avatarText, path, disabled = false}) => {
  const isDisabled = acceptedFiles.length > 0 || disabled;
  const {t} = useTranslation();

  const dispatch = useDispatch();

  const handleShowAvatarPopup = () => {
    if (isDisabled) return;
    dispatch(setModalAdditional(path));
  };

  const avatarFile = Array.isArray(avatar) ? avatar[0] : avatar;

  return (
    <div
      className={`dropzone-multiple__input dropzone-multiple__avatar ${isDisabled ? 'disabled' : ''} ${
        avatar && Object.keys(avatar).length > 0 ? 'has-trash' : ''
      }`}
      onClick={handleShowAvatarPopup}
    >
      <div className={`dropzone-multiple-content`}>
        <div className='dropzone-multiple__icon'>
          {avatar && Object.keys(avatar).length > 0 ? (
            <img src={avatarFile.preview ?? avatarFile?.avatar} onLoad={() => URL.revokeObjectURL(avatar.preview || avatarFile?.avatar)} alt='Avatar Preview' />
          ) : (
            <AvatarIcon />
          )}
        </div>
        <p className='dropzone-multiple-text'>
          {avatar && Object.keys(avatar).length > 0 ? t('DropzoneMultiple.otherAvatar') : avatarText}
        </p>
      </div>
    </div>
  );
};

export default AvatarField;
